import { Component, OnInit } from '@angular/core';
import { ETransactionType } from 'src/app/EBMSuite/models/transaction.model';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}

@Component({
  selector: 'app-invoice-edit',
  templateUrl: './invoice-edit.component.html',
  styleUrls: ['./invoice-edit.component.scss']
})
export class InvoiceEditComponent {
  transactionTypeEnum = ETransactionType;
}
